import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

interface ProfileIframeProps {
  userInfo: string;
  onClose: () => void;
}

function ProfileIframe({ userInfo, onClose }: ProfileIframeProps) {
  return (
    <div className="iframe hide" id="iframe">
      <div className="bgIframe" onClick={onClose} />
      <div className="iframeHolder">
        <div className="closeIframe" onClick={onClose}>
          <span className="closeText">
            <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {i18n.translate('general.back')}
          </span>
        </div>
        <div className="contentIframe">
          <iframe width="100%" height="100%" id="iframeModal" src={userInfo} title="Profile" />
        </div>
      </div>
    </div>
  );
}

export default ProfileIframe;
